/**
 * @file 加盟員Noからデータを参照してフォームに反映する
 */
'use strict'
 
/**
 * @classname ReflectMemberData
 * @classdesc 加盟員Noからデータを参照してフォームに反映する
 */
export default class ReflectMemberData {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.reflect-member-data')
	 */
	constructor($e, controller) {
		console.log('ReflectMemberData.constructor')
		this._$e = $e
		this._controller = controller
		this._$reflectedItemsWrap = $(this._$e.data('reflect-to'))
		this._reflectedItemNames = this.setReflectedItemNames()
		console.log(this._reflectedItemNames)
		this._$e.on('change', () => this.onChange())
		this._controller.on('getMemberDataComplete', () => this.onGetMemberDataComplete())
	}


	/**
	 * 反映対象項目名をセット
	 *
	 * @memberof ReflectMemberData
	 * @return {string[]}
	 */
	setReflectedItemNames() {
		console.log('ReflectMemberData.setReflectedItemNames')
		return Array.prototype.map.call(this._$reflectedItemsWrap.find('[data-response-name]'), element => $(element).data('response-name'))
	}
	

	/**
	 * change イベントのコールバック
	 *
	 * @memberof ReflectMemberData
	 * @return {undefined}
	 */
	onChange() {
		console.log('ReflectMemberData.onChange')
		if (this._$e.val() == '') {
			this._reflectedItemNames.map(reflectedItemName => {
				this._$reflectedItemsWrap.find(`[data-response-name="${reflectedItemName}"]`).text('')
			})
		} else {
			this._controller.getMemberData(this._$e.val())
		}
	}
	

	/**
	 * 加盟員Noから会員情報を取得完了時コールバック
	 *
	 * @memberof ReflectMemberData
	 * @return {undefined}
	 */
	onGetMemberDataComplete() {
		console.log('ReflectMemberData.onGetMemberDataComplete')
		console.log(this._controller._memberData)
		this._reflectedItemNames.map(reflectedItemName => {
			this._$reflectedItemsWrap.find(`[data-response-name="${reflectedItemName}"]`).text(this._controller._memberData[reflectedItemName])
		})
	}
}
